// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type=text] {
  height: 30px;
  width: 100%;
  padding-left: 15px;
}

button[type=reset] {
  border-radius: 30px;
  height: 36px;
  border: 0;
  width: calc(100% + 17px);
  padding-left: 15px;
  color: white;
  font-size: 10px;
  letter-spacing: 0.1px;
  background-color: #a41f35;
  cursor: pointer;
}

button[type=button] {
  border-radius: 30px;
  height: 36px;
  border: 0;
  width: 55%;
  color: white;
  font-size: 10px;
  letter-spacing: 0.1px;
  background-color: #023970;
  cursor: pointer;
}

button:disabled {
  background-color: #023970;
  cursor: not-allowed;
  opacity: 0.7;
}

h1 {
  font-size: 43.75px;
  letter-spacing: 0px;
  font-family: "EB Garamond", serif;
  margin: 0px auto 10px;
  line-height: 1.15em;
  font-weight: 500;
}

h2 {
  font-size: 35px;
  letter-spacing: 0px;
  font-family: "EB Garamond", serif;
  margin: 0px auto 10px;
  line-height: 1.15em;
  font-weight: 500;
}

.title {
  font-size: 43.75px;
  letter-spacing: 0px;
  font-family: "EB Garamond", serif;
  margin: 0px auto 10px;
  line-height: 1.15em;
  font-weight: 500;
}

.subtitle {
  font-size: 30px;
  letter-spacing: 0px;
  font-family: "EB Garamond", serif;
  margin: 0px auto 10px;
  line-height: 1.15em;
  font-weight: 400;
}

.pull-right {
  float: right;
}

input[type=date] {
  border-radius: 30px;
  height: 34px;
  border: 1px solid #ccc;
  width: calc(100% + 5px);
  padding-left: 10px;
}

select {
  border-radius: 30px;
  height: 34px;
  border: 1px solid #ccc;
  width: calc(100% + 17px);
  padding-left: 10px;
}

::placeholder {
  color: #545454;
}

.row {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.row mat-error {
  font-weight: bold;
  padding-bottom: 1.25rem;
  max-width: 75%;
}

.column {
  display: flex;
  flex-direction: column;
  flex: 1 100%;
  margin-right: 20px;
  margin-top: 8px;
}

.table-column {
  display: flex;
  flex-direction: column;
  flex: 1 100%;
  margin-right: 20px;
}

th {
  background-color: #f0f0f0;
  color: #999;
  font-size: 10px;
  font-weight: 600;
  text-align: left;
  padding-top: 15px;
  padding-bottom: 15px;
}

th:nth-child(1) {
  padding-left: 2.5rem;
}

td {
  font-size: 12px;
  font-weight: 500;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}

td:nth-child(1) {
  padding-left: 40px;
}

.table-style {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.heading {
  font-size: 1.5rem;
  font-weight: bold;
  color: #324758;
  margin: 15px 0;
}
.heading mat-icon {
  vertical-align: middle;
}

.customLink:nth-child(1) {
  padding-right: 2rem;
}

.alert-comments {
  width: 50%;
  padding-left: 2rem;
  padding-right: 2rem;
}

.resetstyle {
  border-radius: 30px;
  height: 36px;
  border: 0;
  width: calc(100% + 17px);
  padding-left: 15px;
  color: white;
  font-size: 10px;
  letter-spacing: 0.1px;
  background-color: #a41f35 !important;
  cursor: pointer;
}

::ng-deep .mat-form-field-underline {
  display: none;
}

.loadingMessage {
  width: 100px;
  margin: auto;
}

.section-head {
  font-size: 1.5rem;
  font-weight: bold;
  color: #324758;
  margin: 30px 0;
}

.section-head--buton {
  text-align: right;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}

.missingMentorId {
  color: #d10700;
}

.observation-number {
  width: 500px;
  display: inline-block;
}

.intern-data-pdf-container {
  display: none;
  font-family: serif;
  font-size: 2.5rem;
  margin-top: 5000px;
}

.pdf-logo {
  height: 150px;
  width: auto;
}

:host-context(.teach-theme) .pdf-logo {
  height: auto;
  max-height: 90px;
}

.campus-information-container {
  padding-top: 15px;
}

.certificate-information-container {
  padding-top: 25px;
  padding-bottom: 15px;
}

.logo-container {
  text-align: center;
  margin: 0 auto;
  padding-bottom: 40px;
}

.intern-data {
  font-size: 2.5rem;
  font-weight: lighter;
}

.campus-data {
  font-size: 2.5rem;
  font-weight: bold;
}

.observation-number-column {
  flex: 1 20%;
  margin-top: 0px;
}

.observation-date-column {
  padding-bottom: 15px;
  margin-top: 0px;
}

.observation-date {
  display: block;
}

.cert-name-container {
  text-decoration: underline;
  padding-bottom: 10px;
  font-weight: bold;
}

.campus-info-padding {
  padding-bottom: 0.5em;
}

.ObservationListSection {
  margin: 20px 0 20px 0;
  display: flex;
  flex-direction: row;
}
.ObservationListSection .ObservationsList {
  flex-basis: 33%;
  margin-right: 20px;
}
.ObservationListSection .ObservationsList.withMaterials {
  flex-basis: 60%;
}
.ObservationListSection .ObservationsList .ObservationsList--title {
  font-size: 1.5rem;
  font-weight: bold;
  color: #324758;
  margin: 15px 0;
}
.ObservationListSection .ObservationsList .ObservationsList--title mat-icon {
  vertical-align: middle;
}
.ObservationListSection .ObservationsList .ObservationsList--grid {
  display: grid;
  grid-template-columns: 50% 1fr 1fr;
  grid-template-rows: auto;
  gap: 1em 0px;
  grid-auto-flow: row;
  grid-template-areas: "contactNameHead startDateHead endDateHead" ". . .";
}
.ObservationListSection .ObservationsList .ObservationsList--grid.withMaterials {
  grid-template-columns: 26% 1fr 1fr 1.4fr 1.4fr;
  grid-template-areas: "contactNameHead startDateHead endDateHead videosHead documentsHead" ". . . . .";
}
.ObservationListSection .ObservationsList .ObservationsList--grid.withMaterials .videosHead {
  grid-area: videosHead;
  background-color: #efefef;
  padding: 0.5em;
}
.ObservationListSection .ObservationsList .ObservationsList--grid.withMaterials .documentsHead {
  grid-area: documentsHead;
  background-color: #efefef;
  padding: 0.5em;
}
.ObservationListSection .ObservationsList .ObservationsList--grid.withMaterials.withoutVideos {
  grid-template-columns: 32% 1fr 1fr 1.8fr;
  grid-template-areas: "contactNameHead startDateHead endDateHead documentsHead" ". . . .";
}
.ObservationListSection .ObservationsList .ObservationsList--grid .materialsCell {
  display: flex;
  flex-direction: column;
  gap: 0.35em;
  padding-right: 0.5em;
  min-width: 0;
}
.ObservationListSection .ObservationsList .ObservationsList--grid .materialsCell--link {
  display: flex;
  align-items: center;
  gap: 0.25em;
  color: #1976d2;
  cursor: pointer;
  min-width: 0;
}
.ObservationListSection .ObservationsList .ObservationsList--grid .materialsCell--link mat-icon {
  flex: 0 0 auto;
  font-size: 1.1rem;
  width: 1.1rem;
  height: 1.1rem;
}
.ObservationListSection .ObservationsList .ObservationsList--grid .materialsCell--link.is-loading {
  opacity: 0.7;
}
.ObservationListSection .ObservationsList .ObservationsList--grid .materialsCell--spinner {
  flex: 0 0 auto;
}
.ObservationListSection .ObservationsList .ObservationsList--grid .materialsCell--filename {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ObservationListSection .ObservationsList .ObservationsList--grid .contactNameHead {
  grid-area: contactNameHead;
  background-color: #efefef;
  padding: 0.5em;
}
.ObservationListSection .ObservationsList .ObservationsList--grid .startDateHead {
  grid-area: startDateHead;
  background-color: #efefef;
  padding: 0.5em;
}
.ObservationListSection .ObservationsList .ObservationsList--grid .endDateHead {
  grid-area: endDateHead;
  background-color: #efefef;
  padding: 0.5em;
}
.ObservationListSection .ObservationsList .ObservationsList--grid .contactName {
  margin-left: 10px;
}
.ObservationListSection .ObservationsList .ObservationsList--grid .startDaAte {
  margin-left: 10px;
}
.ObservationListSection .ObservationsList .ObservationsList--grid .endDAte {
  margin-left: 10px;
}

.transcript-button-container {
  display: inline-block;
  vertical-align: top;
}

.download-progress-bar {
  margin-top: 2px;
  max-width: 80px;
}

.download-transcript-progress-bar {
  margin-top: 2px;
  max-width: 175px;
  margin-left: 10px !important;
}

.margin-top-40 {
  margin-top: 40px;
}

.strikethrough-text {
  text-decoration: line-through;
}

.intern-info-button {
  width: 175px !important;
  margin-left: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/intern/intern-details/intern-details.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,iCAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;EACA,iCAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,iCAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;EACA,iCAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,wBAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AACF;AACE;EACE,iBAAA;EACA,uBAAA;EACA,cAAA;AACJ;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,6BAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AAAF;AAEE;EACE,sBAAA;AAAJ;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,UAAA;EACA,kBAAA;EACA,mBAAA;AADF;;AAIA;EACE,mBAAA;EACA,YAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,oCAAA;EACA,eAAA;AADF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,YAAA;EACA,YAAA;AAFF;;AAKA;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AAFF;;AAKA;EACE,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,YAAA;EACA,qBAAA;AAFF;;AAKA;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,WAAA;AAFF;;AAKA;EACE,YAAA;EACA,gBAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,oBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,oBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,WAAA;EACA,eAAA;AAFF;;AAKA;EACE,oBAAA;EACA,eAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,0BAAA;EACA,oBAAA;EACA,iBAAA;AAFF;;AAKA;EAEE,qBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;AAHF;AAKE;EACE,eAAA;EACA,kBAAA;AAHJ;AAKI;EACE,eAAA;AAHN;AAMI;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AAJN;AAMM;EACE,sBAAA;AAJR;AAQI;EACE,aAAA;EACA,kCAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,wEACE;AAPR;AAUM;EACE,8CAAA;EACA,qGACE;AATV;AAYQ;EACE,qBAAA;EACA,yBAAA;EACA,cAAA;AAVV;AAaQ;EACE,wBAAA;EACA,yBAAA;EACA,cAAA;AAXV;AAcQ;EACE,wCAAA;EACA,wFACE;AAbZ;AAkBM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,YAAA;AAhBR;AAmBM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AAjBR;AAmBQ;EACE,cAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;AAjBV;AAoBQ;EACE,YAAA;AAlBV;AAsBM;EACE,cAAA;AApBR;AAuBM;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AArBR;AAwBM;EACE,0BAAA;EACA,yBAAA;EACA,cAAA;AAtBR;AAyBM;EACE,wBAAA;EACA,yBAAA;EACA,cAAA;AAvBR;AA0BM;EACE,sBAAA;EACA,yBAAA;EACA,cAAA;AAxBR;AA2BM;EACE,iBAAA;AAzBR;AA4BM;EACE,iBAAA;AA1BR;AA6BM;EACE,iBAAA;AA3BR;;AAiCA;EACE,qBAAA;EACA,mBAAA;AA9BF;;AAiCA;EACE,eAAA;EACA,eAAA;AA9BF;;AAiCA;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;AA9BF;;AAiCA;EACE,gBAAA;AA9BF;;AAiCA;EACE,6BAAA;AA9BF;;AAiCA;EACE,uBAAA;EACA,4BAAA;AA9BF","sourcesContent":["input[type=text] {\n  height: 30px;\n  width: 100%;\n  padding-left: 15px;\n}\n\nbutton[type=reset] {\n  border-radius: 30px;\n  height: 36px;\n  border: 0;\n  width: calc(100% + 17px);\n  padding-left: 15px;\n  color: white;\n  font-size: 10px;\n  letter-spacing: 0.1px;\n  background-color: #a41f35;\n  cursor: pointer;\n}\n\nbutton[type=button] {\n  border-radius: 30px;\n  height: 36px;\n  border: 0;\n  width: 55%;\n  color: white;\n  font-size: 10px;\n  letter-spacing: 0.1px;\n  background-color: #023970;\n  cursor: pointer;\n}\n\nbutton:disabled {\n  background-color: #023970;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\nh1 {\n  font-size: 43.75px;\n  letter-spacing: 0px;\n  font-family: \"EB Garamond\", serif;\n  margin: 0px auto 10px;\n  line-height: 1.15em;\n  font-weight: 500;\n}\n\nh2 {\n  font-size: 35px;\n  letter-spacing: 0px;\n  font-family: \"EB Garamond\", serif;\n  margin: 0px auto 10px;\n  line-height: 1.15em;\n  font-weight: 500;\n}\n\n.title {\n  font-size: 43.75px;\n  letter-spacing: 0px;\n  font-family: \"EB Garamond\", serif;\n  margin: 0px auto 10px;\n  line-height: 1.15em;\n  font-weight: 500;\n}\n\n.subtitle {\n  font-size: 30px;\n  letter-spacing: 0px;\n  font-family: \"EB Garamond\", serif;\n  margin: 0px auto 10px;\n  line-height: 1.15em;\n  font-weight: 400;\n}\n\n.pull-right {\n  float: right;\n}\n\ninput[type=date] {\n  border-radius: 30px;\n  height: 34px;\n  border: 1px solid #ccc;\n  width: calc(100% + 5px);\n  padding-left: 10px;\n}\n\nselect {\n  border-radius: 30px;\n  height: 34px;\n  border: 1px solid #ccc;\n  width: calc(100% + 17px);\n  padding-left: 10px;\n}\n\n::placeholder {\n  color: #545454;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n\n  mat-error {\n    font-weight: bold;\n    padding-bottom: 1.25rem;\n    max-width: 75%;\n  }\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  flex: 1 100%;\n  margin-right: 20px;\n  margin-top: 8px;\n}\n\n.table-column {\n  display: flex;\n  flex-direction: column;\n  flex: 1 100%;\n  margin-right: 20px;\n}\n\nth {\n  background-color: #f0f0f0;\n  color: #999;\n  font-size: 10px;\n  font-weight: 600;\n  text-align: left;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\nth:nth-child(1) {\n  padding-left: 2.5rem;\n}\n\ntd {\n  font-size: 12px;\n  font-weight: 500;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #ccc;\n}\n\ntd:nth-child(1) {\n  padding-left: 40px;\n}\n\n.table-style {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 20px;\n}\n\n.heading {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #324758;\n  margin: 15px 0;\n\n  mat-icon {\n    vertical-align: middle;\n  }\n}\n\n.customLink:nth-child(1) {\n  padding-right: 2rem;\n}\n\n.alert-comments {\n  width: 50%;\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n\n.resetstyle {\n  border-radius: 30px;\n  height: 36px;\n  border: 0;\n  width: calc(100% + 17px);\n  padding-left: 15px;\n  color: white;\n  font-size: 10px;\n  letter-spacing: 0.1px;\n  background-color: #a41f35 !important;\n  cursor: pointer;\n}\n\n//Remove underline from input form fields\n::ng-deep .mat-form-field-underline {\n  display: none;\n}\n\n.loadingMessage {\n  width: 100px;\n  margin: auto;\n}\n\n.section-head {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #324758;\n  margin: 30px 0;\n}\n\n.section-head--buton {\n  text-align: right;\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 20px;\n}\n\n.missingMentorId {\n  color: #d10700;\n}\n\n.observation-number {\n  width: 500px;\n  display: inline-block;\n}\n\n.intern-data-pdf-container {\n  display: none;\n  font-family: serif;\n  font-size: 2.5rem;\n  margin-top: 5000px;\n}\n\n.pdf-logo {\n  height: 150px;\n  width: auto;\n}\n\n:host-context(.teach-theme) .pdf-logo {\n  height: auto;\n  max-height: 90px;\n}\n\n.campus-information-container {\n  padding-top: 15px;\n}\n\n.certificate-information-container {\n  padding-top: 25px;\n  padding-bottom: 15px;\n}\n\n.logo-container {\n  text-align: center;\n  margin: 0 auto;\n  padding-bottom: 40px;\n}\n\n.intern-data {\n  font-size: 2.5rem;\n  font-weight: lighter;\n}\n\n.campus-data {\n  font-size: 2.5rem;\n  font-weight: bold\n}\n\n.observation-number-column {\n  flex: 1 20%;\n  margin-top: 0px;\n}\n\n.observation-date-column {\n  padding-bottom: 15px;\n  margin-top: 0px;\n}\n\n.observation-date {\n  display: block;\n}\n\n.cert-name-container {\n  text-decoration: underline;\n  padding-bottom: 10px;\n  font-weight: bold;\n}\n\n.campus-info-padding {\n\n  padding-bottom: 0.5em;\n}\n\n.ObservationListSection {\n  margin: 20px 0 20px 0;\n  display: flex;\n  flex-direction: row;\n\n  .ObservationsList {\n    flex-basis: 33%;\n    margin-right: 20px;\n\n    &.withMaterials {\n      flex-basis: 60%;\n    }\n\n    .ObservationsList--title {\n      font-size: 1.5rem;\n      font-weight: bold;\n      color: #324758;\n      margin: 15px 0;\n\n      mat-icon {\n        vertical-align: middle;\n      }\n    }\n\n    .ObservationsList--grid {\n      display: grid;\n      grid-template-columns: 50% 1fr 1fr;\n      grid-template-rows: auto;\n      gap: 1em 0px;\n      grid-auto-flow: row;\n      grid-template-areas:\n        \"contactNameHead startDateHead endDateHead\"\n        \". . .\";\n\n      &.withMaterials {\n        grid-template-columns: 26% 1fr 1fr 1.4fr 1.4fr;\n        grid-template-areas:\n          \"contactNameHead startDateHead endDateHead videosHead documentsHead\"\n          \". . . . .\";\n\n        .videosHead {\n          grid-area: videosHead;\n          background-color: #efefef;\n          padding: 0.5em;\n        }\n\n        .documentsHead {\n          grid-area: documentsHead;\n          background-color: #efefef;\n          padding: 0.5em;\n        }\n\n        &.withoutVideos {\n          grid-template-columns: 32% 1fr 1fr 1.8fr;\n          grid-template-areas:\n            \"contactNameHead startDateHead endDateHead documentsHead\"\n            \". . . .\";\n        }\n      }\n\n      .materialsCell {\n        display: flex;\n        flex-direction: column;\n        gap: 0.35em;\n        padding-right: 0.5em;\n        min-width: 0;\n      }\n\n      .materialsCell--link {\n        display: flex;\n        align-items: center;\n        gap: 0.25em;\n        color: #1976d2;\n        cursor: pointer;\n        min-width: 0;\n\n        mat-icon {\n          flex: 0 0 auto;\n          font-size: 1.1rem;\n          width: 1.1rem;\n          height: 1.1rem;\n        }\n\n        &.is-loading {\n          opacity: 0.7;\n        }\n      }\n\n      .materialsCell--spinner {\n        flex: 0 0 auto;\n      }\n\n      .materialsCell--filename {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n\n      .contactNameHead {\n        grid-area: contactNameHead;\n        background-color: #efefef;\n        padding: 0.5em;\n      }\n\n      .startDateHead {\n        grid-area: startDateHead;\n        background-color: #efefef;\n        padding: 0.5em;\n      }\n\n      .endDateHead {\n        grid-area: endDateHead;\n        background-color: #efefef;\n        padding: 0.5em;\n      }\n\n      .contactName {\n        margin-left: 10px;\n      }\n\n      .startDaAte {\n        margin-left: 10px;\n      }\n\n      .endDAte {\n        margin-left: 10px;\n      }\n    }\n  }\n}\n\n.transcript-button-container {\n  display: inline-block;\n  vertical-align: top;\n}\n\n.download-progress-bar {\n  margin-top: 2px;\n  max-width: 80px;\n}\n\n.download-transcript-progress-bar {\n  margin-top: 2px;\n  max-width: 175px;\n  margin-left: 10px !important;\n}\n\n.margin-top-40 {\n  margin-top: 40px;\n}\n\n.strikethrough-text {\n  text-decoration: line-through;\n}\n\n.intern-info-button {\n  width: 175px !important;\n  margin-left: 10px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
